/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - Lobby card header component
 */

import type { LobbyMetadata } from "@game/domain";
import type React from "react";

interface LobbyCardHeaderProps {
  lobby: LobbyMetadata;
  isFirst: boolean;
}

export const LobbyCardHeader: React.FC<LobbyCardHeaderProps> = ({
  lobby,
  isFirst,
}) => {
  let displayStatus: string;
  let statusClass: string;

  if (!isFirst) {
    displayStatus = "WAITING";
    statusClass = "waiting";
  } else if (lobby.secondsUntilStart <= 5) {
    displayStatus = "STARTING";
    statusClass = "starting";
  } else {
    displayStatus = "OPEN";
    statusClass = "forming";
  }

  return (
    <div className="lobby-card-header">
      <span className="lobby-card-id">
        LOBBY #{lobby.id.substring(0, 6).toUpperCase()}
      </span>
      <span className={`lobby-card-status ${statusClass}`}>
        {displayStatus}
      </span>
    </div>
  );
};
